import React, { lazy, Suspense, useCallback } from 'react';

import { ModalErrorBoundary } from '@services/errorService';
import { Loader } from '@sharedComponents/Loader';

import { GIFT_PACKAGING_LOADER_SIZE } from '../components';
import { useCartPageContext } from '../context';
import { IGiftPackagingData } from '../services';
import { IServicesResponseData } from '../services';
const GiftPackagingModalBody = lazy(() => import('../components/GiftPackagingModalBody/GiftPackagingModalBody'));

export const useGiftPackagingModal = (onModalClose: () => void): JSX.Element => {
  const {
    actions: { addGiftPackaging },
  } = useCartPageContext();

  const onSave = useCallback(
    (data: IServicesResponseData<IGiftPackagingData>) => {
      addGiftPackaging({ giftPackagings: data.serviceItems.giftPackagings, pricesSummary: data.pricesSummary });
      onModalClose();
    },
    [onModalClose, addGiftPackaging],
  );

  return (
    <ModalErrorBoundary onError={onModalClose}>
      <Suspense fallback={<Loader height={GIFT_PACKAGING_LOADER_SIZE} />}>
        <GiftPackagingModalBody onSave={onSave} onModalClose={onModalClose} />
      </Suspense>
    </ModalErrorBoundary>
  );
};
